import { defineStore } from "pinia";
import API from "../api/index.js";

export const useGradingScalesStore = defineStore('gradingScales', {
  state: () => ({
    grading_scales: [],
    isLoading: false,
  }),

  getters: {
    active_scales: (state) => 
      state.grading_scales.filter(g => g.is_active === 1),
    
    sorted_scales: (state) => 
      [...state.grading_scales].sort((a, b) => b.min_score - a.min_score)
  },

  actions: {
    async fetch_grading_scales() {
      this.isLoading = true;
      try {
        const res = await API.fetch_grading_scales();
        this.grading_scales = res.data || [];
      } catch (error) {
        console.error("Failed to fetch grading scales:", error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    add_to_store(new_scale) {
      this.grading_scales.push(new_scale);
    },

    update_in_store(updated_scale) {
      const index = this.grading_scales.findIndex(g => g.id === updated_scale.id);
      if (index !== -1) {
        this.grading_scales[index] = { ...this.grading_scales[index], ...updated_scale };
      }
    },

    remove_from_store(id) {
      this.grading_scales = this.grading_scales.filter(g => g.id !== id);
    },

    // 🔥 HELPER: Given a score, return the matching grade and remark
    get_grade_for_score(score) {
      const numScore = parseFloat(score);
      const match = this.grading_scales.find(g => 
        g.is_active === 1 && 
        numScore >= parseFloat(g.min_score) && 
        numScore <= parseFloat(g.max_score)
      );
      return match || { grade: '-', remark: 'No grade defined' };
    }
  }
});